import { FileUp } from "lucide-react";

import { PRODUCT_NAME } from "@src/shared/brand";
import { VerticalFlexbox } from "@src/shared/components/layout/Flexbox";

export function EmptyCareProtocolOpportunities() {
  return (
    <VerticalFlexbox
      alignItems="center"
      justifyContent="center"
      className="min-h-[360px] rounded-card border border-dashed border-border bg-surface px-8 py-12 text-center"
    >
      <div className="mb-4 flex size-11 items-center justify-center rounded-[13px] bg-primary/5 text-primary">
        <FileUp className="size-5" aria-hidden="true" />
      </div>
      <h2 className="text-lg font-semibold text-surface-foreground">
        No care gaps yet
      </h2>
      <p className="mt-2 max-w-[360px] text-sm leading-6 text-muted-foreground">
        Uploaded care gap lists will appear here after {PRODUCT_NAME.singular}{" "}
        extracts items for patients.
      </p>
    </VerticalFlexbox>
  );
}
